// extracted by mini-css-extract-plugin
module.exports = {"alert":"sqlAX3bF","container":"xZYNaCmM","helperText":"Ip4Jt5d3","cardDetails":"h_7t7DJe","leftPart":"u5HAJDOH","rightPart":"AQF_Zidx","alertTitle":"jVIApQNk","label":"udscgoPC"};